import styled from "styled-components";


interface CalendarViewContainerProps {
  noPadding: boolean;
}
export const CalendarViewContainer = styled.div<CalendarViewContainerProps>`
  padding: 0px;

  ${({ theme, noPadding }) => `
    ${noPadding ? `
      padding: 0;
      ${theme.breakPoints.tablet} {
        top: 0;
        padding: 10px 20px;
        position: static;
      }
    ` : ''}
  `}

  ${({ theme }) => `
    ${theme.breakPoints.desktop} {
      max-width: 960px;
      margin: 0 auto;
    }

    ${theme.breakPoints.tablet} {
      padding: 10px 20px;
    }
  `}

  .legoFormFieldLabel:first-letter {
    text-transform: uppercase;
  }
`;

export const TitleCalendar = styled.h1`
  text-align: center;
  font-size: 16px;
  color: #fff;
`;

export const TitleContainer = styled.div`
  position: absolute;
  top: -50px;
  width: 100%;
  z-index: 4;
  pointer-events: none;
  ${({ theme }) => `
    ${theme.breakPoints.tablet} {
      display: none;
    }
  `}
`;

export const SpinnerContainer = styled.div.attrs(() => ({
  className: 'CalendarSpinnerContainer',
}))`
  width: 100%;
  min-height: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
